import { useState } from 'react';

/**
 * Runs a `callback` whenever `value` changes.
 *
 * Does not run on mount (the first `value` is considered "unchanged").
 *
 * **!!! `callback` should not change `value` or else an infinite rerender loop will be triggered !!!**
 *
 * **!!! If `T` is an object type, `value` must have a stable reference (e.g. be memoized), or else an infinite rerender loop will be triggered !!!**
 */
export function useOnValueChange<T>(value: T, callback: (oldValue: T, newValue: T) => void) {
    const [prevValue, setPrevValue] = useState(value);

    if (value !== prevValue) {
        setPrevValue(value);
        callback(prevValue, value);
    }
}
